/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable no-plusplus */

import axios from 'axios';
import jwt_decode from 'jwt-decode';

import { getIdToken, isResponseValid, throwSAPError } from '../helpers/functions';
import { history } from '../helpers/history';
import i18n from '../helpers/i18nMain';
import {
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  SYSTEM_SELECT,
  LOAD_SALES_ORG_DETAILS,
  LOAD_ORGANIZATION_DATA_STATUS,
  SELECT_SALES_ORG,
  SHOW_HIDE_SALES_ORG_DIALOG,
  LOAD_MATERIAL_GROUP_FILTERED_DATA,
  LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS,
  LOAD_CUSTOMER_MASTER_DATA,
  CHECK_SECURE_CONNECTION,
  CHECK_SECURE_CONNECTION_STATUS,
} from '../helpers/types';

// const getMaterailGroupData = data => {
//   try {
//     const materialGroupData = [];
//     for (let i = 1; i <= 10; i++) {
//       const item = data[`MaterialGroup${i}`];
//       if (item && item !== '') {
//         materialGroupData.push(item);
//       }
//     }
//     return materialGroupData;
//   } catch (err) {
//     return [];
//   }
// };

export const logUserIn = (
  enqueueSnackbar = () => {},
  setSubmitStatus = () => {},
  idToken
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, selectedSalesOrgData, macAddress, environment } = auth;

    const decoded = jwt_decode(idToken);
    const ContactPerson = decoded.jobTitle;
    const rMacAddress = decoded.city;
    const isCheck = environment === 'PRD' ? rMacAddress === macAddress : true;

    if (isCheck) {
      const config = {
        headers: {
          'AZURE-AUTH': `${idToken}`,
        },
        params: {
          // $top: 25,
          'sap-client': client,
          // $filter: `BuPartner eq '${BusinessPartner}'`,
          $filter: `ContactPerson eq '${ContactPerson}'`,
        },
      };
      let materialGroupConfig = {
        headers: {
          'AZURE-AUTH': `${idToken}`,
        },
        params: {
          // $top: 25,
          'sap-client': client,
          // $filter: `SoldToParty eq '${BusinessPartner}'`,
        },
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
      });
      const response = await MainService.get(`/ZAE_I_TC_CB2B_06`, config).catch(throwSAPError);

      if (isResponseValid(response)) {
        const contactPersonData = response.data.d.results;
        const BusinessPartner = response.data.d.results[0].Bp;
        materialGroupConfig = {
          ...materialGroupConfig,
          params: {
            ...materialGroupConfig.params,
            $filter: `SoldToParty eq '${BusinessPartner}' and Vkorg eq '${contactPersonData[0].SalesOrg}'`,
          },
        };
        const salesOrgConfig = {
          headers: {
            'AZURE-AUTH': `${idToken}`,
          },
          params: {
            'sap-client': client,
            $filter: `BuPartner eq '${BusinessPartner}'`,
          },
        };

        const salesOrgResponse = await MainService.get(`/ZAE_I_TC_CB2B_02`, salesOrgConfig).catch(
          throwSAPError
        );
        const materialGroupDataResponse = await MainService.get(
          `/ZAE_I_SP_MATKL_01`,
          materialGroupConfig
        ).catch(throwSAPError);
        setSubmitStatus(false);
        history.push('/');
        const data = salesOrgResponse.data.d.results;
        const materialGroupData = materialGroupDataResponse.data.d.results;
        const isOpenSalesOrgDialog = data.length > 1 && selectedSalesOrgData.SalesOrg === undefined;
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: {
            idToken,
            data,
            BusinessPartner,
            materialGroupData,
            isOpenSalesOrgDialog,
            ContactPerson,
            contactPersonData,
          },
        });
      }
    } else {
      enqueueSnackbar(
        'This device is not configured to use the application. Kindly reach out to AHM IT Team for support',
        {
          variant: 'error',
        }
      );
      setSubmitStatus(false);
    }
  } catch (error) {
    setSubmitStatus(false);
    enqueueSnackbar(i18n.t('authScreenTranslations:SIGN_IN_FAILED'), {
      variant: 'error',
    });
  }
};

export const loadSalesOrgData = (enqueueSnackbar = () => {}) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner } = auth;
    const idToken = await getIdToken(dispatch, getState);

    dispatch({
      type: LOAD_ORGANIZATION_DATA_STATUS,
      payload: { isLoading: true },
    });
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
    });

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `BuPartner eq '${BusinessPartner}'`,
      },
    };

    const response = await MainService.get(`/ZAE_I_TC_CB2B_02`, config).catch(throwSAPError);
    if (isResponseValid(response)) {
      const data = response.data.d.results;

      dispatch({
        type: LOAD_SALES_ORG_DETAILS,
        payload: data,
      });
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('authScreenTranslations:SOMETHING_WENT_WRONG'), {
      variant: 'error',
    });
    dispatch({
      type: LOAD_ORGANIZATION_DATA_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('authScreenTranslations:SOMETHING_WENT_WRONG'),
      },
    });
  }
};

export const loadMatrialFilterData = (enqueueSnackbar = () => {}) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner, selectedSalesOrgData } = auth;
    const idToken = await getIdToken(dispatch, getState);

    dispatch({
      type: LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS,
      payload: { isLoading: true },
    });
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
    });

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        // $top: 25,
        'sap-client': client,
        $filter: `SoldToParty eq '${BusinessPartner}' and Vkorg eq '${selectedSalesOrgData.SalesOrg}'`,
      },
    };
    const response = await MainService.get(`/ZAE_I_SP_MATKL_01`, config).catch(throwSAPError);
    if (isResponseValid(response)) {
      const materialGroupData = response.data.d.results;

      dispatch({
        type: LOAD_MATERIAL_GROUP_FILTERED_DATA,
        payload: materialGroupData,
      });
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('authScreenTranslations:SOMETHING_WENT_WRONG'), {
      variant: 'error',
    });
    dispatch({
      type: LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('authScreenTranslations:SOMETHING_WENT_WRONG'),
      },
    });
  }
};

export const selectSalesOrg = selectedSalesOrgData => dispatch => {
  dispatch({
    type: SELECT_SALES_ORG,
    payload: selectedSalesOrgData,
  });
};

export const handleSalesOrgDialog = isOpen => dispatch => {
  dispatch({
    type: SHOW_HIDE_SALES_ORG_DIALOG,
    payload: isOpen,
  });
};

export const systemSelect = ({ systemIP, client, system, systemName }) => dispatch => {
  dispatch({
    type: SYSTEM_SELECT,
    payload: {
      systemIP,
      client,
      system,
      systemName,
    },
  });
};

export const logUserOut = () => {
  // eslint-disable-next-line no-undef
  history.push('/auth');
  return { type: USER_LOGOUT };
};

export const loadCustomerMasterData = (enqueueSnackbar = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, selectedSalesOrgData } = auth;
    const idToken = await getIdToken(dispatch, getState);
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
    });
    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `Customer eq '${selectedSalesOrgData.BuPartner}' and SalesOrganization eq '${selectedSalesOrgData.SalesOrg}' and DistrChannel eq '${selectedSalesOrgData.DisCha}' and Division eq '${selectedSalesOrgData.Division}'`,
        // $filter: ` Plant eq '${selectedSalesOrgData.Plant}' and SalesOrganization eq '${selectedSalesOrgData.SalesOrg}' `,
      },
    };
    const response = await MainService.get('/ZAE_C_CustomerMasterSalesData', config).catch(
      throwSAPError
    );
    if (isResponseValid(response)) {
      const customerMasterData = response.data.d.results;
      dispatch({
        type: LOAD_CUSTOMER_MASTER_DATA,
        payload: customerMasterData,
      });
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('authScreenTranslations:SOMETHING_WENT_WRONG'), {
      variant: 'error',
    });
  }
};

export const checkSecureIP = (enqueueSnackbar = () => {}, showProceedPopUp = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const MainService = axios.create({
      baseURL: `http://localhost:8080`,
    });
    dispatch({
      type: CHECK_SECURE_CONNECTION_STATUS,
      payload: true,
    });
    const config = {
      headers: {
        // 'AZURE-AUTH': `${idToken}`,
      },
      params: {
        // 'sap-client': client,
      },
    };
    const response = await MainService.get('/b2b-system-check', config).catch(throwSAPError);
    // console.log('response', response);
    if (isResponseValid(response)) {
      showProceedPopUp();
      dispatch({
        type: CHECK_SECURE_CONNECTION,
        payload: {
          isSecure: true,
          isSecureLoading: false,
          macAddress: response.data,
        },
      });
    }
  } catch (error) {
    enqueueSnackbar(
      'This device is not configured to use the application. Kindly reach out to AHM IT Team for support',
      {
        variant: 'error',
      }
    );
    dispatch({
      type: CHECK_SECURE_CONNECTION_STATUS,
      payload: false,
    });
  }
};
